"use client";

import { useIsMobile } from "@universe/ui/hooks/use-mobile";
import { LayoutGrid } from "lucide-react";
import { useTranslations } from "next-intl";

import { AppLink } from "@/components/app-link";
import { useReturnTo } from "@/hooks/useReturnTo";

import { ACCOUNT_CARD_CLASSES, ACCOUNT_CARD_PADDING } from "./accounts-summary";

export default function ViewAllAccountsCard() {
  const tAccounts = useTranslations("accounts");
  const isMobile = useIsMobile();
  const { addReturnToParam } = useReturnTo();
  const iconSize = isMobile ? 36 : 44;

  return (
    <AppLink
      href={addReturnToParam("/accounts")}
      className={`group relative bg-brand-primary/4 border-2 border-dashed border-brand-primary/25 rounded-lg flex flex-col items-center justify-between ${ACCOUNT_CARD_PADDING} hover:border-brand-primary/45 hover:bg-brand-primary/6 transition-all ${ACCOUNT_CARD_CLASSES} flex-shrink-0 shadow-sm backdrop-blur-sm hover:shadow-md snap-center overflow-hidden`}
      style={{
        backdropFilter: "blur(4px)",
        transition:
          "border-color 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease",
      }}
      data-testid="view-all-accounts-card"
    >
      <div
        className="absolute inset-0 rounded-lg pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-[1]"
        style={{
          background:
            "radial-gradient(circle at center, oklch(from var(--brand-primary) l c h / 0.00) 0%, oklch(from var(--brand-primary) l c h / 0.12) 100%)",
        }}
      />

      <div className="flex items-center justify-center pt-0.5 mb-2 relative z-[2]">
        <div
          className="flex items-center justify-center rounded-full border border-brand-primary/15 bg-gradient-to-b from-white to-brand-primary/10 shadow-sm group-hover:border-brand-primary/25 group-hover:from-white group-hover:to-brand-primary/15 transition-colors"
          style={{ width: iconSize, height: iconSize }}
        >
          <LayoutGrid
            className="text-brand-strong"
            size={isMobile ? 18 : 22}
            strokeWidth={2.25}
          />
        </div>
      </div>

      <div className="flex flex-col items-center w-full pb-1 relative z-[2]">
        <span className="text-sm lg:text-base font-semibold text-center leading-tight">
          {tAccounts("viewAllAccountsCardTitle")}
        </span>
        <span className="text-[11px] lg:text-xs text-muted-foreground mt-1 text-center font-normal leading-snug">
          {tAccounts("viewAllAccountsCardDescription")}
        </span>
      </div>
    </AppLink>
  );
}
